import { autobind } from "@typed-decorators/autobind/dist/autobind";
import classNames from "classnames";
import type { ContextType } from "react";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import onClickOutside from "react-onclickoutside";

import * as Routes from "../../generated/routes";
import { ReturnTo } from "../../utils/ReturnTo";
import { AppContext } from "../shared/AppContext";
import { KibelaSymbol } from "../shared/kibela_symbol";

import { PostButtonDropdown } from "./PostButtonDropdown";

export interface PostButtonProps {
  currentUserAccount: string;
  templates: ReadonlyArray<{ id: number; name: string }>;
  canManageTemplates: boolean;
}

interface State {
  isMenuOpen: boolean;
}

class PostButtonBase extends Component<PostButtonProps, State> {
  static readonly contextType = AppContext;
  declare context: ContextType<typeof AppContext>;

  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
  }

  handleClickOutside() {
    this.setState({ isMenuOpen: false });
  }

  @autobind
  handleClick(event) {
    event.preventDefault();
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  render() {
    const returnTo = new ReturnTo(this.context.currentUrl);
    const newNotePath = returnTo.addReturnToParam(Routes.newNotePath());

    return (
      <div className="dropdownBox-container button-withDropdown-container">
        <a href={newNotePath} className={classNames("button is-button-withDropdown-leftPart", "is-button-note")}>
          <KibelaSymbol id="edit" />
          <FormattedMessage id="postButtons.verbs.writeEntry" />
        </a>
        <a
          onClick={this.handleClick}
          className={classNames("button is-button-withDropdown-rightPart", "is-button-note")}
        >
          <KibelaSymbol id="dropdown" />
        </a>
        {this.state.isMenuOpen && (
          <PostButtonDropdown
            currentUserAccount={this.props.currentUserAccount}
            canManageTemplates={this.props.canManageTemplates}
            templates={this.props.templates}
          />
        )}
      </div>
    );
  }
}

export const PostButton = onClickOutside(PostButtonBase);
